import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './FrequencyButton.styled';
import { Heart } from '../../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FrequencyButton = ({
  children,
  doFadeIn,
  isActive,
  handleClick,
  showRecurringNudgeTag = false,
  showHeartIcon = false,
  variant = [],
  ...rest
}) => {
  const {
    t
  } = useTranslation(['blocks.common']);
  return /*#__PURE__*/_jsxs(Styled.FrequencyButton, {
    doFadeIn: doFadeIn,
    isActive: isActive,
    variant: variant,
    "aria-current": isActive ? 'true' : 'false',
    type: "button",
    onClick: e => {
      e.preventDefault();
      handleClick();
    },
    ...rest,
    children: [showRecurringNudgeTag && /*#__PURE__*/_jsxs(Styled.FrequencyButtonNudgeTag, {
      variant: variant,
      children: [t('Frequency.nudgeTag'), " ", /*#__PURE__*/_jsx(Heart, {})]
    }), variant.includes('six_grid_layout_original') && isActive && /*#__PURE__*/_jsx(Styled.CheckIcon, {
      "aria-hidden": "true",
      focusable: "false"
    }), children, variant.includes('six_grid_layout') && showHeartIcon && /*#__PURE__*/_jsx(Styled.HeartIcon, {
      isActive: isActive,
      "aria-hidden": "true",
      focusable: "false"
    })]
  });
};